import { useToggle } from '../../../hooks/useToggle';
import { useTextOverflow } from '../../../hooks/useTextOverflow';
import classNames from 'classnames';
import { Button, Collapse } from 'reactstrap';
import { useConnectionContext } from './ConnectionContext';

interface ConnectionAnswerProps {
  answerText: string;
  showPopulationButton: boolean;
  onPopulateInput?: () => void;
}

export const ConnectionAnswer = ({ answerText, showPopulationButton, onPopulateInput }: ConnectionAnswerProps) => {
  const [isOpen, toggle] = useToggle(false);
  const { isReadOnly } = useConnectionContext();

  const { elementRef: textRef, isOverflowing } = useTextOverflow<HTMLParagraphElement>({
    text: answerText,
    maxLines: 2,
  });

  return (
    <>
      <div className='d-flex align-items-center'>
        <span className='text-sm text-ThemeTextMedium pr-5'>Answer:</span>
        <div className='flex-grow-1' style={{ minWidth: 0 }}>
          <p
            ref={textRef}
            className={classNames('mb-0 text-ThemeTextDark fw-bold', {
              'text-clamp-2': isOverflowing,
              'text-right': !isOverflowing,
              'cursor-pointer': isOverflowing,
            })}
            onClick={toggle}
          >
            {answerText}
          </p>
        </div>
        <div className='d-flex align-items-center'>
          {isOverflowing ? (
            <i
              className={classNames('fa-light text-ThemeIconSecondary ms-1 cursor-pointer', {
                'fa-caret-up': isOpen,
                'fa-caret-down': !isOpen,
              })}
              onClick={toggle}
            ></i>
          ) : null}
          {showPopulationButton && onPopulateInput && !isReadOnly ? (
            <Button
              color='link'
              className='text-sm me-2'
              onClick={(e) => {
                e.stopPropagation();
                onPopulateInput();
              }}
            >
              <i className='fa-light fa-arrow-right-to-arc ms-1 text-sm' />
            </Button>
          ) : null}
        </div>
      </div>
      {isOverflowing ? (
        <Collapse isOpen={isOpen} className='my-2 p-2'>
          {answerText}
        </Collapse>
      ) : null}
    </>
  );
};
